const { produce } = require("immer");

const init = {
  uid: null,
  name: null,
  description: null,
  licences: []
  // settings: {},
  // users: [],
  // preview: {
  //   name: null,
  //   ext: null,
  //   size: null,
  //   data: null
  // }
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_projectForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
      });

    case "UPDATE_projectForm":
      return produce(state, draft => {
        Object.assign(draft, action.form/*, {
          preview: Object.assign(draft.preview, action.form.preview)
        }*/);
      });

    case "RESET_projectForm":
      return init;

    default:
      return state;
  }
}
